export default __webpack_public_path__ + "app-promo-afl-LG-nosponsor@3x.d3e6168.png";